import DefaultService from 'assets/img/default-service.png';
import { useMemo } from 'react';
import { UPLOAD_FILE_ADDRESS_PREFIX } from 'utils/constants';
import { useSvcImgList } from '../hook/useSvcImgList';
import './CommonJobSvcImg.less';

interface Iprops {
  revxTypeId?: number;
  revxId?: number;
  isOneOf?: boolean;
  image?: string;
}

const CommonJobSvcImg = (props: Iprops) => {
  const { revxTypeId, revxId, image } = props;

  const svcImgList = useSvcImgList();

  const imgSrc = useMemo(() => {
    const imgObj = svcImgList.find(
      (item) => item.revxId === revxId && item.revxTypeId === revxTypeId
    );
    if (imgObj) {
      return imgObj.src;
    } else {
      return '';
    }
  }, [svcImgList, revxId, revxTypeId]);

  return (
    <>
      {image || imgSrc ? (
        <div className="commonJobSvcImg-box">
          <img
            className="commonJobSvcImg-default"
            src={image ? `${UPLOAD_FILE_ADDRESS_PREFIX}${image}` : imgSrc}
            alt={''}
            onError={function (e) {
              const img = e.target as HTMLImageElement;
              img.src = DefaultService;
            }}
          />
        </div>
      ) : (
        <div className="commonJobSvcImg-box">
          <img
            className="commonJobSvcImg-default"
            src={DefaultService}
            alt={''}
          />
        </div>
      )}
    </>
  );
};

export default CommonJobSvcImg;
